$(document).ready(function(){
  
  if($('.owl-carousel').length > 0){
    $('.owl-carousel').owlCarousel({
      loop:true,
      margin:10,
      items: 1,
      autoplay:6000,
      dots:true,
      animateOut: 'slideOutUp',
      animateIn: 'slideInUp'
    })
  }


//   if (window.location.href.indexOf("/products/") > -1) {
//     if ($('.var-invent').length > 0) {
//         $('.var-invent').each(function () {
//             var varid = $(this).attr('var_id');
//             var varqty = $(this).attr('var_qty');
//             setTimeout(function () {
//                 var idd = $('[name="id"]').val();
//                 if (varid == idd && varqty > 0) {
//                     // Stock greater than 0: Orange
//                     $(".product_info-dot span").removeAttr('class');
//                     $(".product_info-dot span").attr('class', 'product_info-dot--main orange');
//                 } else if (varid == idd && varqty == 0) {
//                     // Stock is 0: Red
//                     $(".product_info-dot span").removeAttr('class');
//                     $(".product_info-dot span").attr('class', 'product_info-dot--main red');
//                 }
//             }, 500);
//         });
//     }
// }

          if (typeof greenLabelColor === "undefined" || !greenLabelColor) {
            greenLabelColor = "green"; // Default to green if not set
        }
        
        if (window.location.href.indexOf("/products/") > -1) {
            if ($('.var-invent').length > 0) {
                $('.var-invent').each(function () {
                    var varid = $(this).attr('var_id');
                    var varqty = $(this).attr('var_qty');
                    setTimeout(function () {
                        var idd = $('[name="id"]').val();
                        if (varid == idd && varqty > 0) {
                            // Stock greater than 0: Use the selected color (green or orange)
                            $(".product_info-dot span").removeAttr('class');
                            $(".product_info-dot span").attr('class', 'product_info-dot--main ' + greenLabelColor);
                        } else if (varid == idd && varqty <= 0) {
                            // Stock is 0: Red
                            $(".product_info-dot span").removeAttr('class');
                            $(".product_info-dot span").attr('class', 'product_info-dot--main red');
                        }
                    }, 500);
                });
            }
        }

  // $(document).on('change','.line-item__actions .quantity-input',function(){
  //   var val = $(this).val();
  //   var ppp = $(this).closest('line-item.line-item').find('.line-item__info .comp-price').attr('data-attr');
  //   ppp = Number(ppp.replace(/[^0-9.-]+/g,""));
  //     var cmp = val * ppp;
  //     $(this).closest('line-item.line-item').find('.line-item__info .comp-price').text(cmp);
  // })




  
})